// extracted by mini-css-extract-plugin
export default {"btnContainer":"UserInfo_btnContainer__BA68p","buyContainer":"UserInfo_buyContainer__KEIXj","showDiplomacontainer":"UserInfo_showDiplomacontainer__8WyBg"};